export default __webpack_public_path__ + "static/media/phone-call-1.ae3e5bf6.svg";